import { render, staticRenderFns } from "./withdrawOrOutCommissionChanelCard.vue?vue&type=template&id=61d4b11d&scoped=true"
import script from "./withdrawOrOutCommissionChanelCard.vue?vue&type=script&lang=js"
export * from "./withdrawOrOutCommissionChanelCard.vue?vue&type=script&lang=js"
import style0 from "./withdrawOrOutCommissionChanelCard.vue?vue&type=style&index=0&id=61d4b11d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d4b11d",
  null
  
)

export default component.exports